"use client";

import { ProviderProps } from "@/types/util";

import { PasswordResetProvider } from "@/context/passwordReset";
import { EmailProvider } from "@/context/passwordReset/email";
import { SecuritySettingsProvider } from "@/context/util/securitySettings";

export function PasswordResetProviders(props: Pick<ProviderProps, "children">) {
  return (
    <SecuritySettingsProvider>
      <PasswordResetProvider>
        <EmailProvider>{props.children}</EmailProvider>
      </PasswordResetProvider>
    </SecuritySettingsProvider>
  );
}
